export * from './service/configuracion.service';
export * from './configuracion-compania.dto';